module.exports = __webpack_public_path__ + "static/img/home_yesterday_amount.2a881414.png";